import { render, staticRenderFns } from "./Home_stretches.vue?vue&type=template&id=20c63973"
import script from "./Home_stretches.vue?vue&type=script&lang=js"
export * from "./Home_stretches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports